<script setup>
import XlButton from '../xl/XlButton.vue';
import XlCard from '../xl/XlCard.vue';
import XlTag from '../xl/XlTag.vue';

const props = defineProps({
  count: { type: Number, default: 0 },
  // Reassigning somebody who already has a broker takes them off that broker's
  // book, so it is said before the action rather than discovered after it.
  alreadyAssigned: { type: Number, default: 0 },
  canAssignBrokers: { type: Boolean, default: false },
});

const emit = defineEmits(['assign', 'message', 'export', 'remove', 'cancel']);
</script>

<template>
  <XlCard v-if="props.count" padded tone="brand" class="policyholder-bulk" data-testid="bulk-bar">
    <b>{{ props.count }} selected</b>
    <XlTag v-if="props.alreadyAssigned" tone="warning">
      {{ props.alreadyAssigned }} already {{ props.alreadyAssigned === 1 ? 'has' : 'have' }} a broker
    </XlTag>
    <span class="policyholder-bulk__spacer" />
    <XlButton v-if="props.canAssignBrokers" size="sm" @click="emit('assign')">
      <template #icon>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M16 20v-1.5a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4V20" /><circle cx="9.5" cy="7" r="3.2" />
          <path d="M17 4.2a3.2 3.2 0 0 1 0 5.9M21 20v-1.5a4 4 0 0 0-3-3.8" />
        </svg>
      </template>
      Assign a broker
    </XlButton>
    <XlButton :variant="props.canAssignBrokers ? 'ghost' : 'filled'" size="sm" @click="emit('message')">
      <template #icon>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3.5 7 8.5 6 8.5-6" />
        </svg>
      </template>
      Send a message
    </XlButton>
    <XlButton variant="ghost" size="sm" @click="emit('export')">Export</XlButton>
    <XlButton variant="ghost" size="sm" class="policyholder-bulk__remove" @click="emit('remove')">Remove</XlButton>
    <XlButton variant="ghost" size="sm" class="policyholder-bulk__cancel" @click="emit('cancel')">Cancel</XlButton>
  </XlCard>
</template>

<style scoped>
.policyholder-bulk {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.policyholder-bulk b {
  font-family: var(--xl-font-family);
  font-size: var(--xl-font-size-base);
  color: var(--xl-color-primary-text);
}

.policyholder-bulk__spacer { flex: 1; }

.policyholder-bulk__remove { color: var(--xl-color-error); }

/* Leaving the selection is not one of the four things you can do to it, so it
   carries no outline of its own. */
.policyholder-bulk__cancel {
  border-color: transparent;
  box-shadow: none;
}
</style>
